import React, { useEffect, useState } from "react";
import axios from "axios";

import "../Css/Notification.css";

const NotificationForm = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [notifications, setNotifications] = useState([]);
  const [files, setFiles] = useState([]);

  useEffect(() => {
    fetchNotifications();
  }, [files]);

  useEffect(() => {
    if (window.CKEDITOR && window.CKEDITOR.instances.description) {
      return;
    }

    const existingScript = document.querySelector(
      "script[src='https://cdn.ckeditor.com/4.17.2/standard/ckeditor.js']"
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://cdn.ckeditor.com/4.17.2/standard/ckeditor.js";
      script.async = true;
      document.body.appendChild(script);

      script.onload = () => {
        if (window.CKEDITOR) {
          window.CKEDITOR.replace("description");
        }
      };
    } else {
      // If script is already present, directly initialize CKEditor
      if (window.CKEDITOR) {
        window.CKEDITOR.replace("description");
      }
    }

    return () => {
      if (window.CKEDITOR && window.CKEDITOR.instances.description) {
        window.CKEDITOR.instances.description.destroy();
      }
    };
  }, [description]);

  const fetchNotifications = async () => {
    try {
      const response = await axios.get(
        "https://api.gkaglobal.org/restgka/notification.php"
      );
      console.log("Fetch Respose", response.data);
      if (response.data.status === "success") {
        setNotifications(response.data.data);
      } else {
        setNotifications([]);
      }
    } catch (error) {
      console.error("Error fetching notifications", error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const ckeditorInstance = window?.CKEDITOR?.instances?.description;
    if (!ckeditorInstance) {
      alert("CKEditor not initialized.");
      return;
    }

    const ckeditorData = ckeditorInstance.getData().trim();
    const trimmedTitle = title ? title.trim() : "";

    if (!trimmedTitle || !ckeditorData) {
      alert("Title and Description are required.");
      return;
    }

    const requestData = {
      Title: title.trim(),
      Description: ckeditorData.trim(),
    };

    const jsonPayload = JSON.stringify(requestData);
    console.log(jsonPayload);
    console.log("Request Payload:", requestData.toString());

    try {
      const response = await axios.post(
        "https://api.gkaglobal.org/restgka/inoti.php",
        requestData,
        JSON.stringify(requestData),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      console.log("API Response Data:", response.data);
      console.log("Api requesr data", requestData);

      if (response.data.status === "success") {
        alert("Notification added successfully!");
        setTitle("");
        ckeditorInstance.setData("");
        fetchNotifications();
      } else {
        alert("Error: " + response.data.message);
      }
    } catch (error) {
      console.error("Submission Error:", error);
      alert("An error occurred while submitting.");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this notification?")) {
      try {
        const response = await axios.post(
          "https://api.gkaglobal.org/restgka/dnoti.php",
          JSON.stringify({ id }),
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        if (response.data.status === "success") {
          alert(response.data.message);
          setFiles((prevFiles) => prevFiles.filter((file) => file.id !== id));
          fetchNotifications();
        } else {
          alert("Failed to delete notification.");
        }
      } catch (error) {
        console.error("Error deleting file:", error);
        alert("Error deleting file");
      }
    }
  };

  return (
    <div className="container4">
      <h2 className="text-center3">Add Notification</h2>
      <div className="form-group2">
        <label>Title</label>
        <input
          type="text"
          name="title"
          className="form-control"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
      </div>
      <div className="form-group3">
        <label htmlFor="description">Description</label>
        <div className="form-group1">
          <textarea
            className="ck-editor"
            id="description"
            name="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows="4"
            style={{ width: "100%" }}
          />
        </div>
      </div>

      <button className="btn4 btn-primary btn-block" onClick={handleSubmit}>
        Submit
      </button>

      <h2 className="mt-5 text-center">Notifications</h2>
      <div className="table-responsive">
        <table className="table3 table-bordered mt-3">
          <thead>
            <tr>
              <th>Title</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {notifications.length > 0 ? (
              notifications.map((notification) => (
                <tr key={notification.id}>
                  <td>{notification.Title}</td>
                  <td
                    dangerouslySetInnerHTML={{
                      __html: notification.Description,
                    }}
                  ></td>
                  <td>
                    <button
                      className="btn6 btn-danger"
                      onClick={() => handleDelete(notification.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center4">
                  No notifications found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NotificationForm;
